import { render, staticRenderFns } from "./BSTableUniqueSelect.vue?vue&type=template&id=c238101a&scoped=true"
import script from "./BSTableUniqueSelect.vue?vue&type=script&lang=js"
export * from "./BSTableUniqueSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c238101a",
  null
  
)

export default component.exports